import { otpHost } from 'config/env.conf';
import InnerFrame from 'components/inner-frame/inner-frame';
const baseUrl = `${otpHost}/#/purse/`;

export default [{
    name: 'purseList',
    path: 'list',
    component: InnerFrame,
    meta: {
        title: '钱包列表',
        src: baseUrl,
        icon: 'turbo-ui-wallet'
    }
}];


// WEBPACK FOOTER //
// ./src/router/router.purse.js